import type { CameraConfig } from '@/workflow-runner/_contract/config';

export const CAMERA_DEFAULTS: CameraConfig = {
    navigationMode: 'guided',
    foldedElevation: 20,
    panelsElevation: 6,
    autoplayGlideFraction: 0.15,
    operationAngleDegrees: 30,
    operationElevation: 20,
    naturalLessThanInspectionOffset: [10, 2, -1],
    naturalResultSettlementOffsets: {
        addition: [10, 2, 5],
        subtraction: [10, 2, 5],
        multiplication: [10, 2, 6],
        division: [10, 2, 5],
    },
    operationPadding: 1.15,
    overviewPadding: 1.0,
    fov: 50,
    navigationDurationMs: 700,
};
